<div class="container">
    <div class="row">
        <div class="col">
            <div class="jumbotron w-100">
                <h1 class="text-capitalize">Mappa</h1>
                <p>Ci sono {{ get().length }} timbrate registrate nel sistema</p>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col">
            <div id="mapView" style="height: 600px; position: relative"></div>
        </div>
    </div>
</div>